import React, { useState, useEffect } from "react";
import "./style.scss";

import Navbar from "../navbar";
import Footer from "../footer";
import { Link } from "gatsby";
import { getIpData } from "../../helper";

import img1 from "../../images/blogphotos/7 Ways To Choose The Perfect Mattress.jpg";
import img2 from "../../images/blogphotos/The Magic of Memory Foam.jpg";
import img3 from "../../images/blogphotos/7 Habits of Healthy Sleepers.jpg";
import img4 from "../../images/blogphotos/The Right Time To Find A New Mattress.jpg";
import img5 from "../../images/blogphotos/Orthopedic Mattresses for Back Pain.jpg";
import img6 from "../../images/blogphotos/New Year Sleep Resolution.jpg";
import img7 from "../../images/blogphotos/All about Mattresses for a Good Night Sleep.jpg";
import img8 from "../../images/blogphotos/How Can An Old Mattress Affect Your Sleep.jpg";
import img9 from "../../images/blogphotos/Good Sleep Makes Better Athletes.jpg";
import img10 from "../../images/blogphotos/Sleep  A Perfect Way To Regulate Emotions And Health.jpg";
import img11 from "../../images/blogphotos/How Sleep Boosts Immunity System Against Covid-19.jpg";

import imgsm1 from "../../images/blogsmall/7 Ways To Choose The Perfect Mattress.jpg";
import imgsm2 from "../../images/blogsmall/The Magic of Memory Foam.jpg";
import imgsm3 from "../../images/blogsmall/7 Habits of Healthy Sleepers.jpg";
import imgsm4 from "../../images/blogsmall/The Right Time To Find A New Mattress.jpg";
import imgsm5 from "../../images/blogsmall/Orthopedic Mattresses for Back Pain.jpg";
import imgsm6 from "../../images/blogsmall/New Year Sleep Resolution.jpg";
import imgsm7 from "../../images/blogsmall/All about Mattresses for a Good Night Sleep.jpg";
import imgsm8 from "../../images/blogsmall/How Can An Old Mattress Affect Your Sleep.jpg";
import imgsm9 from "../../images/blogsmall/Good Sleep Makes Better Athletes.jpg";
import imgsm10 from "../../images/blogsmall/Sleep  A Perfect Way To Regulate Emotions And Health.jpg";
import imgsm11 from "../../images/blogsmall/How Sleep Boosts Immunity System Against Covid-19.jpg";

import SEO from "../seo";

const data = [
  {
    img: "https://eclipsemattress.in/assets/blog/optmise-your-sleep-banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/mattress-care-101-card.jpg",
    title: "Optimise Your Sleep Environment",
    date: "August 22, 2022",
    link: "/blog/optimise-your-sleep-environment/",
  },

  {
    img: "https://eclipsemattress.in/assets/blog/how-often-banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/mattress-care-101-card.jpg",
    title: "How Often Should You Replace Your Mattress",
    date: "July 20, 2022",
    link: "/blog/how-often-should-you-replace-your-mattress/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/replace-your-mattress-banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/mattress-care-101-card.jpg",
    title: "6 Signs You Need To Replace Your Mattress",
    date: "June 19, 2022",
    link: "/blog/6-signs-you-need-to-replace-your-mattress/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/mattress-care-101-banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/mattress-care-101-card.jpg",
    title: "Mattress Care 101",
    date: "May 5, 2022",
    link: "/blog/mattress-care-101/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/how-to-fall-asleep-fast-banner.jpg",
    imgsm:
      "https://eclipsemattress.in/assets/blog/how-to-fall-asleep-fast-card.jpg",
    title: "How To Fall Asleep Fast",
    date: "April 12, 2022",
    link: "/blog/how-to-fall-asleep-fast/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/benefits-of-belgium-latex-banner.jpg",
    imgsm:
      "https://eclipsemattress.in/assets/blog/benefits-of-belgium-latex-card.jpg",
    title: "Benefits of Natural Belgium Latex",
    date: "December 27, 2021",
    link: "/blog/benefits-of-belgium-latex/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/memory-foam-banner.png",
    imgsm: "https://eclipsemattress.in/assets/blog/memory-foam-card.png",
    title: "Benefits of Memory Foam",
    date: "December 17, 2021",
    link: "/blog/benefits-of-memory-foam/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/benefits-of-tencel-banner.png",
    imgsm: "https://eclipsemattress.in/assets/blog/benefits-of-tencel-card.png",
    title: "Benefits of Tencel",
    date: "December 16, 2021",
    link: "/blog/benefits-of-tencel/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/tencel-vs-cotton-banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/tencel-vs-cotton-card.jpg",
    title: "Tencel vs Cotton",
    date: "December 13, 2021",
    link: "/blog/tencel-vs-cotton/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/whats-your-sleep-animal-banner.png",
    imgsm:
      "https://eclipsemattress.in/assets/blog/whats-your-sleep-animal-card.png",
    title: "What's your sleep animal?",
    date: "Nov 10, 2021",
    link: "/blog/whats-your-sleep-animal/",
  },

  {
    img: "https://eclipsemattress.in/assets/blog/benefitsofbonnell_banner.png",
    imgsm: "https://eclipsemattress.in/assets/blog/benefitsofbonnell_card.png",
    title: "Benefits of Bonnell Spring",
    date: "Nov 02, 2021",
    link: "/blog/benefits-of-bonnell-spring/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/bonnellvspocket_banner.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/bonnellvspocket_card.jpg",
    title: "Bonnell Spring vs Pocket Spring",
    date: "Oct 28, 2021",
    link: "/blog/bonnell-spring-vs-pocket-spring/",
  },
  {
    img: "https://eclipsemattress.in/assets/blog/Eclipse_SM_Post_Oct-43.jpg",
    imgsm: "https://eclipsemattress.in/assets/blog/Eclipse_SM_Post_Oct-44.jpg",
    title: "Memory Foam vs Latex Foam",
    date: "Oct 12, 2021",
    link: "/blog/memory-foam-vs-latex-foam/",
  },
  {
    img: img11,
    imgsm: imgsm11,
    title: "How Sleep Boosts Immunity System Against Covid-19",
    date: "May 14, 2020",
    link: "/blog/how-sleep-boosts-immunity-system-against-covid-19/",
  },
  {
    img: img10,
    imgsm: imgsm10,
    title: "Sleep: A Perfect Way To Regulate Emotions And Health",
    date: "April 9, 2020",
    link: "/blog/sleep-a-perfect-way-to-regulate-emotions-and-health/",
  },
  {
    img: img9,
    imgsm: imgsm9,
    title: "Good Sleep Makes Better Athletes",
    date: "March 24, 2020",
    link: "/blog/good-sleep-makes-better-athletes/",
  },
  {
    img: img8,
    imgsm: imgsm8,
    title: "How Can An Old Mattress Affect Your Sleep?",
    date: "February 28, 2020",
    link: "/blog/how-can-an-old-mattress-affect-your-sleep/",
  },
  {
    img: img7,
    imgsm: imgsm7,
    title: "All about Mattresses for a Good Night Sleep",
    date: "January 21, 2020",
    link: "/blog/all-about-mattresses-for-a-good-night-sleep/",
  },
  {
    img: img6,
    imgsm: imgsm6,
    title: "New Year Sleep Resolution",
    date: "December 28, 2019",
    link: "/blog/new-year-sleep-resolution/",
  },
  {
    img: img5,
    imgsm: imgsm5,
    title: "Orthopedic Mattresses for Back Pain?",
    date: "December 21, 2019",
    link: "/blog/orthopedic-mattresses-for-back-pain/",
  },
  {
    img: img4,
    imgsm: imgsm4,
    title: "The Right Time To Find A New Mattress",
    date: "November 24, 2019",
    link: "/blog/the-right-time-to-find-a-new-mattress/",
  },
  {
    img: img3,
    imgsm: imgsm3,
    title: "7 Habits of Healthy Sleepers",
    date: "October 12, 2019",
    link: "/blog/7-habits-of-healthy-sleepers/",
  },
  {
    img: img2,
    imgsm: imgsm2,
    title: "The Magic of Memory Foam",
    date: "September 28, 2019",
    link: "/blog/the-magic-of-memory-foam/",
  },
  {
    img: img1,
    imgsm: imgsm1,
    title: "7 Ways To Choose The Perfect Mattress",
    date: "September 15, 2019",
    link: "/blog/7-ways-to-choose-the-perfect-mattress/",
  },
];

function scrollDown() {
  const sliderList = document.querySelector(".blogouter__slider__list");

  sliderList.scrollBy({ top: 65, behavior: "smooth" });
}

function scrollUp() {
  const sliderList = document.querySelector(".blogouter__slider__list");

  sliderList.scrollBy({ top: -65, behavior: "smooth" });
}

export default function Blog() {
  const [currentBlog, setCurrentblog] = useState(0);

  async function getIP() {
    const data = await getIpData();
    console.log("Ip data", data);
  }

  useEffect(() => {
    getIP();
  });

  return (
    <div className="blogouter">
      <SEO
        title="Mattress Blog | Best Mattress Brand In India | Eclipse International"
        description="Stay updated with the latest tips and updates about the Sleep, mattresses and Bed Accessories regularly from our experts."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <Navbar path="/blog/" />
      <div className="blogouter__content">
        <div className="blogouter__containertop">
          <h1 className="heading-primary">Blog</h1>
          <div className="blogouter__slider">
            <div className="row">
              <div className="col col-12 col-md-7">
                <Link to={data[currentBlog].link}>
                  <img
                    alt="blog image"
                    className="blogouter__slider__img"
                    src={data[currentBlog].img}
                  ></img>
                </Link>
              </div>
              <div className="col col-12 col-md-5">
                <div className="blogouter__slider__header">
                  Popular Resources
                </div>
                <div className="blogouter__slider__list">
                  {data.map((item, i) => (
                    <Link to={item.link}>
                      <div
                        // onClick={() => setCurrentblog(i)}
                        className={`blogouter__slider__list__item ${currentBlog === i &&
                          false &&
                          "blogouter__slider__list__item--active"
                          }`}
                      >
                        {item.title}
                      </div>
                    </Link>
                  ))}
                </div>

                <div className="blogouter__slider__buttons">
                  <button
                    className="blogouter__slider__list__down"
                    onClick={scrollUp}
                  >
                    <i class="fas fa-angle-up"></i>
                  </button>
                  <button
                    className="blogouter__slider__list__up"
                    onClick={scrollDown}
                  >
                    <i class="fas fa-angle-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="blogouter__listing">
          <div className="blogouter__listing__container">
            <div className="row">
              {data.map((item, i) => (
                <div className="col col-12 col-md-6 col-lg-4 col-xl-3">
                  <Link to={item.link}>
                    <div className="blogouter__listing__card">
                      <img alt="blog image" src={item.imgsm}></img>
                      <div className="blogouter__listing__card__foreground"></div>
                      <div className="blogouter__listing__card__overlay">
                        <div>
                          <div className="blogouter__listing__card__overlay__title">
                            {item.title}
                          </div>
                          <div className="blogouter__listing__card__overlay__date">
                            {item.date}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="blogouter__listing__title">{item.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
